import { render, staticRenderFns } from "./expirePay.vue?vue&type=template&id=68a3de2d&scoped=true&"
import script from "./expirePay.vue?vue&type=script&lang=js&"
export * from "./expirePay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a3de2d",
  null
  
)

export default component.exports